import styled from 'styled-components'
import { contentWidth } from '@/theme/tokens'
// The page surface + footer live in the shared @components/PublicPage shell;
// this file only styles what is specific to the per-section frame.

export const Container = styled.main`
	width: 100%;
	/* The shared content column — the SiteHeader aligns to this same width and
	   36px gutter (see theme/layout contentShell); the 40px top matches the
	   shared overview's header→title breathing room. */
	max-width: ${contentWidth};
	margin: 0 auto;
	padding: 40px 36px 64px;

	@media (max-width: 980px) {
		padding: 24px 20px 48px;
	}

	@media (max-width: 600px) {
		padding: 16px 14px 40px;
	}
`

export const TopBar = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 24px;
`

/** Tightens the shared Breadcrumbs' own vertical padding inside the TopBar. */
export const CrumbRow = styled.div`
	nav {
		padding: 0;
	}
`
